<template>
  <Message v-if="visible" severity="error" class="my-2" icon="pi pi-exclamation-triangle" @close="onMessageClose" closable >
    {{ message }}
  </Message>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core

// Components
import Message from 'primevue/message';

// Composables

// Stores

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================
defineProps({
    visible: {
        type: [Boolean, null],
        default: false
    },
    message: {
        type: [String, null],
        default: 'An error has occurred while processing your request. Please try again.'
    }
});

const emit = defineEmits(['close']);

const onMessageClose = () => {
    emit('close');
};

// ===============================
// COMPOSABLES & STORES
// ===============================

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================

</script>
